import React from "react";
import "../HomePage/HomePage.css";
import { Card } from "pepsico-ds";
import { useNavigate } from "react-router-dom";
import urls from "../../configmap/config.json";
const ConsultingHomePage = () => {
  const navigate = useNavigate();
  const handleChatNavigation = () => {
    navigate("/spend-wise-hub/chat-assistant");
  };

  const handleServiceNowNavigation = () => {
    window.open(urls.intakeFormURL, "_blank");
  };

  const handleUploadEngagementNavigation = () => {
    navigate("/spend-wise-hub/upload-engagement_data");
  };

  const handleEngagementHistoryNavigation = () => {
    navigate("/spend-wise-hub/engagement-history");
  };
  const click = () => {
    console.log("click");
  };
  return (
    <div className="homeContainer">
      <div className="$font-heading-h6-bold">
        What would you like to do today?
      </div>
      <div className="consultingCardContainer">
        {/* Hide Consulting Search */}
        {/* <div className="singleCard" onClick={handleChatNavigation}>
          <Card border ellipsis={false} icon="quickreply">
            <div>
              <div className="$font-body-medium">Consulting Search​</div>
              <div className="$font-xsmall-regular">
                Before you submit intake request, explore to find past
                engagements like yours. Save yourself some money on past work.​
              </div>
            </div>
          </Card>
        </div> */}
        <div className="singleCard" onClick={handleServiceNowNavigation}>
          <Card border ellipsis={false} icon="assignment_ind">
            <div>
              <div className="$font-body-medium">Consulting Intake​</div>
              <div className="$font-xsmall-regular">
                Didn’t find anything in search? Submit a new request for
                approval.
              </div>
            </div>
          </Card>
        </div>
        <div className="singleCard" onClick={handleUploadEngagementNavigation}>
          <Card border ellipsis={false} icon="assignment">
            <div>
              <div className="$font-body-medium">
                Close Out Consulting Request
              </div>
              <div className="$font-xsmall-regular">
                After Consulting engagement, complete form & upload documents.
              </div>
            </div>
          </Card>
        </div>
        <div className="singleCard" onClick={handleEngagementHistoryNavigation}>
          <Card border ellipsis={false} icon="fact_check">
            <div>
              <div className="$font-body-medium">Engagement History</div>
              <div className="$font-xsmall-regular">
                View your engagement form data at a glance.
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};
export default ConsultingHomePage;
